import React, { useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import ChildAccountList from '../../../components/Multi/ChildAccount/AccountList';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import CreateButton from '../../../components/Tools/CreateButton';
import MainFilter from '../../../components/Tools/MainFilter';
import Spinner from '../../../components/Tools/spinner';
import DashboardFilter from '../../Dashboard/components/DashboardFilter';
import { exportAccounts, exportDepartmentAccounts } from '../../../helper/Api';
import { downloadSafeFile } from '../../../helper/Utils';

const emptyFilter = {
    searchStr: "",
    fromDate: "",
    toDate: "",
    dateColumn: "",
    department_id: "",
    tier: "",
    district_id: "",
    district_name: "",
};

const ChildAccountListPage = ({ isHolding = false }) => {
    const { authData, financialYears } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [filterPayload, setFilterPayload] = useState(emptyFilter);
    const [filterApplied, setFilterApplied] = useState(emptyFilter);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setFilterPayload(filterApplied);
        setOpen(false);
    };
    const handleFilterClick = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    };
    
    const handleInput = async (e) => {
      const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }

    const handleFilterRemove = async (name) => {
        setFilterApplied((prev) => {
            const newPayload = {
                ...prev,
                [name]: "",
            };
            if (name === "district_id") {
                newPayload.district_name = "";
            }
            setFilterPayload(newPayload);
            return newPayload;
        });
    }


    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const handleExportAccounts = async () => {
        const departmentId = authData.user.department_id;
        if (!departmentId) {
            toast.error("Department not found for logged in user", {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        try {
            setLoading(true);
            const response = isHolding
                ? await exportDepartmentAccounts(departmentId)
                : await exportAccounts(departmentId);
            if (response?.data?.status && response?.data?.url) {
                const fileName = isHolding
                    ? "department_account_details.xlsx"
                    : "account_details.xlsx";
                if (!downloadSafeFile(response.data.url, fileName)) {
                    toast.error("Invalid or unsafe download URL", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            } else {
                toast.error(response?.data?.message || "Failed to export accounts", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        } catch (error) {
            toast.error("Something went wrong while exporting accounts", {
                position: toast.POSITION.TOP_CENTER
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-2'>
                 <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>{isHolding ? "Holding Bank Accounts" : "Limit Bank Accounts"}</h4>
                        <CustomBreadcrumbs linksArray={[]} title={isHolding ? "Holding Bank Accounts" : "Limit Bank Accounts"}/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button type="button" className="navigation_button" onClick={handleExportAccounts} disabled={loading}>
                                <span className="fs-14px">Export Accounts List</span>
                            </button>
                        </div>
                    </div>
                </div>
                <DashboardFilter 
                    openFilterModal={setOpen} 
                    filterPayload={filterApplied} 
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
                <ChildAccountList
                    searchStr={filterApplied.searchStr}
                    tier={filterApplied.tier}
                    district_id={filterApplied.district_id}
                    isHolding={isHolding}
                />
            </div>
            { authData.user.user_type === 'l3' && <CreateButton title={isHolding ? "Add Holding Bank Account" : "Add Limit Bank Account"} url={isHolding ? "/addchildAccount/holding" : "/addchildAccount"}/> }

            <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen}
                filterPayload={filterPayload}
                handleFilterClick={handleFilterClick}
                isDepartmentRequired={false}
            />
        </div>
    )
}
export default ChildAccountListPage
